import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminRoles = () => {
    const [roles, setRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        role_name: "",
    });
    const [editId, setEditId] = useState(null);

    // Fetch existing roles
    const fetchRoles = async () => {
        try {
            const response = await axios.get("https://api.biznetusa.com/api/get-roles");
            if (response.data.status === 200) {
                setRoles(response.data.roles);
            } else {
                toast.error("Failed to fetch roles.");
            }
        } catch (error) {
            console.error("Error fetching roles:", error);
            toast.error("An error occurred while fetching roles.");
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const handleStore = async () => {
        const dataToSend = {
            role_name: formData.role_name,
        };

        console.log("Data to send:", dataToSend);

        try {
            const response = await axios.post(
                "https://api.biznetusa.com/api/store-role",
                dataToSend,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status === 200) {
                toast.success(response.data.message || "Role added successfully.");
                fetchRoles();
                setFormData({ role_name: "" });
                setShowModal(false);
            } else {
                toast.error(response.data.message || "Failed to add role.");
            }
        } catch (error) {
            console.error("Error adding role:", error);
            toast.error("An error occurred while adding the role.");
        }
    };

    // Handle Update
    const handleUpdate = async () => {
        const dataToSend = {
            role_name: formData.role_name,
        };

        console.log("Data to send:", dataToSend);

        try {
            const response = await axios.put(
                `https://api.biznetusa.com/api/update-role/${editId}`,
                dataToSend,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status === 200) {
                toast.success(response.data.message || "Role updated successfully.");
                fetchRoles();
                setFormData({ role_name: "" });
                setEditId(null);
                setShowModal(false);
            } else {
                toast.error(response.data.message || "Failed to update role.");
            }
        } catch (error) {
            console.error("Error updating role:", error);
            toast.error("An error occurred while updating the role.");
        }
    };


    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (editId) {
            await handleUpdate();
        } else {
            await handleStore();
        }
    };

    // Handle Delete
    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(
                `https://api.biznetusa.com/api/deleterole/${id}`
            );
            if (response.data.status === 200) {
                fetchRoles();
                toast.success("Role deleted successfully.");
            } else {
                toast.error(response.data.message || "Failed to delete role.");
            }
        } catch (error) {
            console.error("Error deleting role:", error);
            toast.error("An error occurred while deleting the role.");
        }
    };

    // Handle Edit
    const handleEdit = (role) => {
        setEditId(role.id);
        setFormData({
            role_name: role.role_name,
        });
        setShowModal(true);
    };

    return (
        <Container className="py-4">
            <div className="d-flex justify-content-between">
                <h2 className="text-start mb-4">Role Management</h2>
                <Button variant="primary" className="mb-3" onClick={() => setShowModal(true)}>
                    Add Role
                </Button>
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Role Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {roles.map((role, index) => (
                        <tr key={role.id}>
                            <td>{index + 1}</td>
                            <td>{role.role_name}</td>
                            <td>
                                <Button variant="info" className="me-2" onClick={() => handleEdit(role)}>
                                    Edit
                                </Button>
                                <Button variant="danger" onClick={() => handleDelete(role.id)}>
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal for Adding/Editing */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editId ? "Edit Role" : "Add Role"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Role Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter role name"
                                value={formData.role_name}
                                onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            {editId ? "Update" : "Add"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default AdminRoles;
